import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';

//pages and comps
import Login from './pages/login';
import Dashboard from './pages/dashboard';
import Profile from './pages/profile';

import ProtectedRoute from './protected-route';
import { useAppDispatch, useAppSelector } from './app/hooks';
import { isAuthenticated, logout } from './slices/auth.slice';
import PublicRoute from './public-route';
import Main from './pages/main';

//styles
import 'devextreme/dist/css/dx.light.css';
import "react-datepicker/dist/react-datepicker.css";
import "./styles/scss/styles.scss";
import ForgotPassword from './pages/forgotPassword';
import ResetPassword from './pages/resetPassword';

function App() {

  const authenticated: boolean = useAppSelector(isAuthenticated);
  const dispatch = useAppDispatch();

  useEffect(() => {
    // getting tokenExpiredAt and validate;
    const stringToken = JSON.parse(localStorage.getItem('tokenExpiredAt')!);
    const isValidToken: boolean = stringToken ? (new Date(stringToken).getTime() > new Date().getTime()) ? true : false : false;
    if (!isValidToken) {
      dispatch(logout());
    }
  }, [dispatch])

  return (
    <BrowserRouter>
      <Routes>
        {
          (!authenticated) ? <Route element={<PublicRoute isAuth={authenticated} />}>
            <Route index path="/login" element={<Login />}></Route>
            <Route index path="/forgot-password" element={<ForgotPassword />}></Route>
            <Route index path="/reset-password" element={<ResetPassword />}></Route>
            <Route path="/" element={<Navigate to="/login" replace />}></Route>
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Route> :
            <Route element={<ProtectedRoute isAuth={authenticated} />}>
              <Route path="/" element={<Main />}>
                <Route path="/dashboard" element={<Dashboard />}></Route>
                {/* <Route path="/settlement" element={<Bills />}></Route> */}
                <Route path="/profile" element={<Profile />}></Route>
                <Route path="/" element={<Navigate to="/dashboard" replace />}></Route>
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Route>
            </Route>
        }
        {/* <Route path="*" element={<p>There's nothing here: 404!</p>} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;

